module.exports = __webpack_public_path__ + "static/prodimage1-2378175954f48c02c64a5bc37d4b9b53.jpg";